import { BaseSettings, BaseThemeType } from 'Shared/frontend/themes/BaseSettings';
import { merge } from 'Shared/frontend/merge';
import { DeepPartial } from 'Shared/frontend/SettingsProvider';
import { NunitoSans } from 'Shared/frontend/fonts/NunitoSans';
import { Imbue } from 'Shared/frontend/fonts/Imbue';
import { NoticiaText} from 'Shared/frontend/fonts/NoticiaText';
import { SpaceGrotesk} from 'Shared/frontend/fonts/SpaceGrotesk';
import { Calendar } from 'Shared/frontend/icons/Calendar';
import { Contact } from 'Shared/frontend/icons/Contact';
import { FoodMenu } from 'Shared/frontend/icons/FoodMenu';
import { Home } from 'Shared/frontend/icons/Home';



export class BotanyViewSettings extends BaseSettings
{
	palette()
	{
		return {
			background: 'white',		
			text: 'black',
			feature: '#292849', //BlueishPurple
			inverseText: 'white !important',

			/* Eg the mobile nav colour */
			dimBackground: '#000000',

			food: '', 
			drinks: '',
			
			// CJ added: needed to change scrollBar colors for light theme
			scrollBar: {
				scrollbarColor: '#fff #d3cdcd !important',
			}
		};
	}

	poster()
	{
		return merge(super.poster(), {
			shared: {
				root: {
					color: 'white',
					backgroundColor: this.palette().feature,
				},
				dateBar: {
					color: this.palette().feature,
					backgroundColor: this.palette().background,
				},
			}
		});
	}

	fontIncludes()
	{
		return [
			NunitoSans,
			NoticiaText,
			Imbue,
			SpaceGrotesk
		];
	}

	fonts() {
		return {
			text: '"Space Grotesk", serif',
			teaser: '"Space Grotesk", serif',
			heading: '"Space Grotesk", serif',
			tagline: '"Space Grotesk", serif',
			buttons: '"Space Grotesk", serif',
			desktopNav: '"Space Grotesk", serif',
			menuItem: '"Space Grotesk", serif',
			mobileNav: '"Space Grotesk", serif',
			subNav: '"Space Grotesk", serif',
		};
	}

	
	page()
	{
		return merge(super.page(), {
			heading: {
				color: this.palette().feature,
			},
			section: {
				title: {
					color: this.palette().feature,
					fontWeight: '700',
					fontSize:'clamp(1.8rem, 4vw, 3rem)!important',
				//	letterSpacing: 3, 
					
				},

			
				teaser:{
					color: this.palette().inverseText,
					fontFamily: this.fonts().teaser,
					fontWeight: '500',
					fontSize:'clamp(1.2rem, 5vw, 3rem)!important',	
				},

			
				tagline:{
					color: this.palette().feature,
					fontFamily: this.fonts().tagline,
					fontWeight: '300 !important',
					fontSize:'clamp(1.2rem, 5vw, 2rem)!important',	
				},

				
			},

			widgets: {
				subNav: {
					button: {
						backgroundColor: this.palette().text
					}
				},
			},

			button: {
				backgroundColor: this.palette().feature,
				borderRadius: '0.4em',
				color: 'white',
			},
		});
	}


	siteTheme()
	{
		const base = super.siteTheme();
		const palette = this.palette();

		const settings = merge(base, <DeepPartial<BaseThemeType>>{
			nav:{
				desktop:{
					wrap:{
						backgroundColor: palette.feature,
		
						button:{
						color: 'white !important',
						}
					},
				},

				mobile:{		
					backgroundWrap: {background: palette.feature,},
					overlay:{background: palette.feature},
				
					button:{
						background: palette.feature,
						color: palette.inverseText,
						//icons
						svg: {
							fill: palette.inverseText,
						},
					},
				},
			},

			event: {
				artist: {
					heading: {
						color: palette.feature,
						fontFamily: 'sans-serif'
					},
					wide: {
						nameAndTime: {
							color: palette.feature
						}
					},
					narrow: {
						nameAndTime: {
							backgroundColor: palette.feature
						}
					}, 
					genresAndLocation: {
						color: palette.feature
					} 
				}
			},

			//TODO share most of this with the townie. eg 'ColouredDarkTheme' parent
			menu: {
				subNav: {
					button: {
						color: palette.feature,
						border: 'solid 3px',
						borderColor: palette.feature,
					},
					buttonType: type => ({ backgroundColor: palette.background })
				},
				section: {
					heading: {
						fontFamily: this.fonts().menuItem,
						fontSize:'clamp(2rem, 20vw, 50rem)!important',
						color: palette.feature,
					},
				},
				item: {
					type: 'imageless',
					title: { 
						fontFamily: this.fonts().menuItem,
						fontSize: '1.3em',
					},
				},
			},

			subNavButton: {
				borderRadius: '0.4em'
			},
		});

		// XXX if we want to entirely remove or overwrite a base setting or two then do so here 
		return settings;
	}

	navContent()
	{
		return {
			desktop: [
				{label:'Home',			link:'frontend/Home'},
				{label:'Food & Drink',	link:'frontend/Menu'},
				{label:'Events',		link:'frontend/Events'},
				{label:'Hire',			link:'frontend/Hire'},
				{label:'Contact',		link:'frontend/Contact'}
			],
			mobile: {
				maxButtons: 5,
				includeMoreButton: true,
				links: [
					{label:'Home',		link:'frontend/Home',		icon: Home},
					{label:'Menu',		link:'frontend/Menu',		icon: FoodMenu},
					{label:'Events',	link:'frontend/Events',		icon: Calendar},
					{label:'Hire',		link:'frontend/Hire', 		icon: Contact},
					{label:'Contact',	link:'frontend/Contact',	icon: Contact},
				]
			}
		};
	}
}

